import React from 'react';
import { Link } from 'react-router';
import { useBrand } from '../../../app/config/brand';

export const Footer: React.FC = () => {
  const brand = useBrand();
  return (
    <footer className="text-white px-4 sm:px-6 py-4 mt-auto" style={{ backgroundColor: brand.colors.secondary }}>
      <div className="flex flex-col sm:flex-row justify-between items-center text-sm gap-2">
        <div className="opacity-80 text-center sm:text-left text-xs sm:text-sm">
          &copy; {brand.app.year} {brand.app.copyright}
          <span className="hidden sm:inline"> | Version: {brand.app.version} | Customer #{brand.user.customerNumber}</span>
        </div>
        <div className="flex gap-4 opacity-80">
          {Object.values(brand.footerLinks).map((link, i) => {
            // Internal routes (/legal/…) render as router links — a full reload
            // would drop SPA state for no reason. Anything else stays a plain
            // anchor (external URLs).
            const isInternal = link.url.startsWith('/');
            const className = 'hover:opacity-100 min-h-touch flex items-center';
            return (
              <React.Fragment key={link.label}>
                {i > 0 && <span className="hidden sm:inline">|</span>}
                {isInternal ? (
                  <Link to={link.url} className={className}>{link.label}</Link>
                ) : (
                  <a href={link.url} className={className}>{link.label}</a>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </footer>
  );
};
